// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"88355480","227":"4080f0f6","232":"d9dfe14c","237":"b7155290","526":"33e4c878","643":"aa86f4d3","656":"1f8a0a9b","774":"65aa2b69","829":"bde0742c","854":"0ddefaa5","872":"36185653","883":"d838cf20"}[chunkId] + ".chunk.js";
};